import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useQuestionCache } from './cache'
import { type QuestionUpdateInput, type QuestionUpdateSuccess, toResponseError } from '@terros/common'

export function useUpdateQuestion(): UpdateHookResponse<QuestionUpdateInput, QuestionUpdateSuccess> {
  const cache = useQuestionCache()
  const mutation = useTantalimMutation<QuestionUpdateInput, QuestionUpdateSuccess>({
    url: '/question/manage/update',
  })

  async function update(input: QuestionUpdateInput): Promise<QuestionUpdateSuccess> {
    try {
      const res = await mutation.mutateAsync(input)
      cache.clearList()
      cache.clearItem(input.question.questionId)
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
